import { Tab } from './types.js';
import { toTab } from './utils.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useMonitorTabPref = (): UsePrefState<Tab> =>
  usePrefState('room.monitor.tab', Tab.Overview, {
    deserialize: toTab
  });
